const routes = [
    {
        path: "/prices",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'productprice_index'
        },
        component_full_path: 'prices/pages/Index.vue'
    }
];

export default routes;
